import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getQuizAlerts, updateQuizAlerts } from '../../store/quizzes/actions'
import Toggle from '@/components/UI/Toggle'

const ReportAlerts: React.FC<{ quizId: string }> = ({ quizId = '' }) => {
  const { t } = useTranslation()
  const [forAttempted, setForAttempted] = useState(false)
  const [forNotAttempted, setForNotAttempted] = useState(false)

  useEffect(() => {
    const getReportAlerts = async () => {
      try {
        const response: any = await getQuizAlerts(quizId)
        if (response.alerts?.includes('weekly_attempted_report')) {
          setForAttempted(true)
        }
        if (response.alerts?.includes('weekly_unattempted_report')) {
          setForNotAttempted(true)
        }
      } catch (error) {}
    }

    getReportAlerts()
  }, [quizId])

  const updateReportAlerts = async (attempted: any, unattempted: any) => {
    let updatedAlerts = []
    if (attempted) {
      updatedAlerts.push('weekly_attempted_report')
    }
    if (unattempted) {
      updatedAlerts.push('weekly_unattempted_report')
    }
    try {
      await updateQuizAlerts(quizId, updatedAlerts)
    } catch (error) {
      console.log(error)
    }
  }

  const onAlertChange = (event: any, type: any) => {
    if (type === 'attempted') {
      setForAttempted(event.target.checked)
      updateReportAlerts(forNotAttempted, event.target.checked)
    } else if (type === 'unattempted') {
      setForNotAttempted(event.target.checked)
      updateReportAlerts(forAttempted, event.target.checked)
    }
  }

  return (
    <div>
      <label className="font-16 font-600 mb-1">{t('Report Alerts')}</label>
      <div className="mb-2">{t('Manage quiz alerts')}.</div>

      <Toggle
        toggled={forAttempted}
        onToggle={(event: any) => onAlertChange(event, 'attempted')}
        label={t('Receive weekly report of users who have attempted the quiz')}
        InputPosition="start"
      />

      <Toggle
        toggled={forNotAttempted}
        onToggle={(event: any) => onAlertChange(event, 'unattempted')}
        label={t(
          'Receive weekly report of the users who have not attempted the quiz',
        )}
        InputPosition="start"
      />
    </div>
  )
}

export default ReportAlerts
